import styled from 'styled-components';
import ds from 'designsystem';
import enlargeFont from 'common/methods/enlargeFont';

/* eslint react/destructuring-assignment: "off" */
/* eslint no-confusing-arrow: "off" */

const ListItem = styled.span`
    font-size: ${props => props.isActive ? enlargeFont(ds.fs('m')) : ds.fs('m')};
    transition: font-size 0.5s;
    font-family: ${ds.get('type.fontFamily.Poppins')};
    font-weight: ${ds.get('type.fontWeight.bold')};
    line-height: ${ds.get('type.lineHeight.s')};
    &:hover{
      color: ${ds.brand('product')};
  }
`;

export default ListItem;



// WEBPACK FOOTER //
// ./src/elements/ListItem.js